import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Footer.css";
import logo from "./logon.png";
import twitter from "./x-nailoong.png";
import dex from "./dex-nailoong.png";
import { useLanguage } from "../../context/LanguageContext";
import { getT } from "../../translations";

gsap.registerPlugin(ScrollTrigger);

function Footer() {
  const footerRef = useRef(null);
  const innerRef = useRef(null);
  const titleRef = useRef(null);
  const logoRef = useRef(null);
  const iconsRef = useRef(null);
  const langRef = useRef(null);
  const descRef = useRef(null);
  const { lang, setLang } = useLanguage();
  const t = getT(lang);

  useEffect(() => {
    const footer = footerRef.current;
    const title = titleRef.current;
    const logoEl = logoRef.current;
    const icons = iconsRef.current;
    const langWrap = langRef.current;
    const desc = descRef.current;
    if (!footer || !innerRef.current) return;
    const els = [title, logoEl, icons, langWrap, desc].filter(Boolean);
    gsap.set(els, { opacity: 0, y: 20 });
    gsap.to(els, {
      opacity: 1,
      y: 0,
      duration: 0.45,
      stagger: 0.08,
      ease: "power2.out",
      scrollTrigger: { trigger: footer, start: "top 92%", toggleActions: "play none none none" },
    });
    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  const toggleLanguage = () => {
    setLang(lang === "zh" ? "en" : "zh");
  };

  return (
    <footer ref={footerRef} className="footer">
      <div ref={innerRef} className="footer-inner">
        <h2 ref={titleRef} className="footer-title">{t("footer.socials")}</h2>

        <img ref={logoRef} src={logo} alt="Nailong 奶龙" className="footer-logo" />
        <div ref={iconsRef} className="footer-icons">
          <a
            href="https://x.com/i/communities/2029948076094324765"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X Community"
          >
            <img src={twitter} alt="X" />
          </a>
          <a
            href="https://dexscreener.com/solana/djeseq7g4khfnehqcamfkmtpuvufvx4q89eprwlnl2ss"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="DXScreener"
          >
            <img src={dex} alt="DXScreener" />
          </a>
        </div>

        <div ref={langRef} className="footer-lang-wrap">
          <button
            type="button"
            className="footer-lang-trigger"
            onClick={toggleLanguage}
            aria-label={t("language.label")}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            <span>{lang === "zh" ? "Chinese" : "English"}</span>
          </button>
        </div>

        <p ref={descRef} className="footer-description">
          <span className="desktop-line">{t("footer.rights")}</span>
          <span className="mobile-line">
            {t("footer.rightsMobile")}<br />{t("footer.rightsMobileLine2")}
          </span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
